import { render } from "./SORecom.vue?vue&type=template&id=170c66ce"
import script from "./SORecom.ts?vue&type=script&lang=ts"
export * from "./SORecom.ts?vue&type=script&lang=ts"
script.render = render

export default script